import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Collapse extends Component {
  static propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    triggerType: PropTypes.string.isRequired,
    secondaryLabel: PropTypes.string,
    actionTriggerLabel: PropTypes.string,
    onActionTriggerClick: PropTypes.func,
    expanded: PropTypes.bool,
    expandedChange: PropTypes.func,
  };

  static defaultProps = {
    id: null,
    label: null,
    children: null,
    triggerType: 'chevron',
    secondaryLabel: null,
    actionTriggerLabel: null,
    onActionTriggerClick() {},
    expanded: false,
    expandedChange() {},
  };

  constructor(props) {
    super(props);

    this.state = {
      expanded: this.props.expanded,
    };
  }

  expandToggleClick() {
    this.setState({ expanded: !this.state.expanded });

    this.props.expandedChange({ id: this.props.id, expanded: !this.state.expanded });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.expanded !== this.props.expanded) {
      this.setState({ expanded: this.props.expanded });
    }
  }

  render() {
    const trigger =
      this.props.triggerType === 'tree' ? (
        this.state.expanded ? (
          <i className="Icon Icon-minus" />
        ) : (
          <i className="Icon Icon-plus" />
        )
      ) : this.state.expanded ? (
        <i className="Icon Icon-chevron-up" />
      ) : (
        <i className="Icon Icon-chevron-down" />
      );

    const triggerClasses =
      this.props.triggerType === 'tree'
        ? 'Collapse-toggle Collapse-toggle--tree u-px-3 u-py-1'
        : 'Collapse-toggle u-px-3 u-py-2';
    return (
      <div className="Collapse" key={this.props.id} id={`collapse-${this.props.id}`}>
        <div className="u-flex u-items-center u-justify-between u-pr-4">
          <div className={triggerClasses} onClick={this.expandToggleClick.bind(this)}>
            {trigger}
            <span>{this.props.label}</span>
          </div>
          {this.props.secondaryLabel !== null && (
            <span className="u-text-xs u-text-old-dark-grey">{this.props.secondaryLabel}</span>
          )}
          {this.props.actionTriggerLabel !== null && (
            <span
              className="u-text-xs u-text-old-primary-color-blue u-cursor-pointer hover:u-underline"
              onClick={this.props.onActionTriggerClick}>
              {this.props.actionTriggerLabel}
            </span>
          )}
        </div>
        {this.state.expanded && <div className="Collapse-content">{this.props.children}</div>}
      </div>
    );
  }
}
